import React, {Component, Fragment} from "react";
import {Link} from "react-router-dom";

import {Logo, SvgCross} from "./common/common";
import {reduxWrapper} from "../globalState";
import errorIcon from "../resources/icons/stop_red.svg"
import successIcon from "../resources/icons/success_green.svg"
import warningIcon from "../resources/icons/warning_yellow.svg"
import {AppearTransition} from "./animations";
import {forEachObj} from "../lib/tools";

//<editor-fold desc="Header">
class HeaderRender extends Component {
	message = {};
	
	render() {
		const {cart, message} = this.props;
		let cartQty = 0;
		forEachObj(cart, x => cartQty += x.qty || 0);
		
		if (message)
			this.message = message || {};
		const {text: msgText, type: msgType} = this.message;
		
		return (
			<Fragment>
				<header id="header">
					<div className="maxWidth">
						<Link className="logo" to={"/"}>
							<Logo/>
						</Link>
					</div>
				</header>
				<AppearTransition animation="genie" show={!!message}>
					<div className={"statusMessage " + msgType}>
						{msgType === "error" && <img src={errorIcon} className="icon" alt="error"/>}
						{msgType === "success" && <img src={successIcon} className="icon" alt="success"/>}
						{msgType === "warning" && <img src={warningIcon} className="icon" alt="warning"/>}
						<span className="text">{msgText}</span>
						<SvgCross onClick={() => this.props.removeMessage()}/>
					</div>
				</AppearTransition>
			</Fragment>
		)
	}
}

export const Header = reduxWrapper("loadMessage", "getRemoveMessage")(HeaderRender);


// WEBPACK FOOTER //
// ./src/components/structure.js